<template>
    <div 
        :class="{
            'flex-column' : !isHorizontal, 
            'mt2' : isHorizontal
        }" 
        style="flex:1;" class="flex"
    >

        <div 
            v-for="(image, index) in images" 
            :key="index" 
            :class="{
                'w-25' : isHorizontal,
                'pr2' : index !== images.length - 1 && isHorizontal,
                'pb2' : index !== images.length - 1 && !isHorizontal }"
        >

            <img  :src="image.path" class="grow pointer  w-100 h-100" @click="$emit('select', index)" />

        </div>

    </div>
</template>

<script>
export default {
    props: {
        images: {
            type: Array,
            required: true
        }
    },
    computed: {
        isHorizontal() {
            return this.$mq === 'xs' || this.$mq === 'md';
        }
    }
};
</script>
